import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  Grid,
  TextField,
} from "@mui/material";
import InfiniteScroll from "react-infinite-scroller";
import Iconify from "../components/iconify";
import { useNavigate, useSearchParams } from "react-router-dom";
import { get, post } from "src/utils/networkUtils";

export default function RedeemCodes() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [load, setLoad] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();

  const [generationCode, setGenerationCode] = useState({
    count: 0,
    amount: 0,
  });

  const handleGenerationCode = (e) => {
    const { id, value } = e.target;
    setGenerationCode((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const submitGenerationCode = () => {
    post(`/admin/redeem-codes`, generationCode).then(() => {
      setGenerationCode({ count: 0, amount: 0 });
      getCodes();
    });
  };

  useEffect(() => {
    //getCodes()
  }, [setSearchParams, searchParams, navigate]);

  const dowloadRedeemCodes = () => {
    get(`/admin/export-redeem-codes`, { responseType: "blob" }).then(function (
      response
    ) {
      const downloadUrl = window.URL.createObjectURL(new Blob([response]));

      const link = document.createElement("a");

      link.href = downloadUrl;

      link.setAttribute("download", "prize-draw-entries.csv");

      document.body.appendChild(link);

      link.click();

      link.remove();
    });
  };

  const getCodes = async (page) => {
    try {
      const offset = page > 1 ? (page - 1) * 100 : 0;
      const response = await get(
        `/admin/redeem-codes?offset=${offset}&limit=${100}`
      );

      if (response.codes.length > 0) setRows([...rows, ...response.codes]);
      else setLoad(false);
      return true;
    } catch (error) {
      return false;
    }
  };

  return (
    <>
      <Helmet>
        <title> Redeem Codes </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Typography variant="h4" gutterBottom>
            Redeem Codes
          </Typography>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:arrow-circle-down-outline" />}
            onClick={() => dowloadRedeemCodes()}
          >
            Download Codes
          </Button>
        </Stack>

        <Grid container sx={{ mb: 2 }}>
          <Grid item xs={12} sx={{ mt: 2 }}>
            <Typography variant="h6" gutterBottom>
              Generate Redeem Codes
            </Typography>
            <Grid container>
              <Grid item xs={5} sx={{ m: 0, p: 1 }}>
                <TextField
                  id="count"
                  label="Count"
                  fullWidth
                  value={generationCode.count}
                  variant="outlined"
                  onChange={handleGenerationCode}
                />
              </Grid>
              <Grid item xs={5} sx={{ m: 0, p: 1 }}>
                <TextField
                  id="amount"
                  label="Amount"
                  fullWidth
                  value={generationCode.amount}
                  variant="outlined"
                  onChange={handleGenerationCode}
                />
              </Grid>
              <Grid item xs={2} sx={{ m: 0, p: 2 }}>
                <Button
                  variant="outlined"
                  fullWidth
                  onClick={submitGenerationCode}
                >
                  Generate
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Card>
          {false ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <InfiniteScroll
              pageStart={0}
              loadMore={getCodes}
              hasMore={load}
              loader={
                <div className="loader" key="loader">
                  Loading ...
                </div>
              }
            >
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Code ID</TableCell>
                      <TableCell>Code</TableCell>
                      <TableCell>Amount</TableCell>
                      <TableCell>UserId</TableCell>
                      <TableCell>Available</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows?.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.codeId}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.code}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.amount}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.user_id}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {!row.is_used ? (
                            <>
                              <Iconify
                                icon={"eva:checkmark-circle-2-outline"}
                                sx={{ color: "green" }}
                              />
                            </>
                          ) : (
                            <Iconify
                              icon={"eva:close-circle-outline"}
                              sx={{ color: "red" }}
                            />
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </InfiniteScroll>
          )}
        </Card>
      </Container>
    </>
  );
}
